export const SHOW_SNACKBAR_INFO = "SHOW_SNACKBAR_INFO";
export const SHOW_SNACKBAR_ERROR = "SHOW_SNACKBAR_ERROR";
export const SHOW_SNACKBAR_WARNING = "SHOW_SNACKBAR_WARNING";
